import i18next from 'i18next';
import { i18nConfig } from 'qw-ui-lib-v2';
import { initReactI18next } from 'react-i18next';
import en from './en';
import fr from './fr';
import hu from './hu';
import th from './th';
import vi from './vi';
import pt_br from './pt-br';
import zh_tw from './zh-tw';
import es_419 from './es-419';

i18next.use(initReactI18next).init({
  fallbackLng: 'en',
  lowerCaseLng: true,
  partialBundledLanguages: true,
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    hu: { translation: hu },
    th: { translation: th },
    vi: { translation: vi },
    'pt-br': { translation: pt_br },
    'zh-tw': { translation: zh_tw },
    'es-419': { translation: es_419 },
  },
  react: { useSuspense: false },
  interpolation: { escapeValue: false },
});

export function setLanguage(lang = 'en') {
  i18nConfig.changeLanguage(lang);
  i18next.changeLanguage(lang);
}
const I18n = i18next;
export default I18n;
